import { LastViewedObject } from "../../types/types";
import Page from "../Page";
import useFetchPage from "../hooks/useFetchPage";
import List from "./List";

interface Props {
  setLastViewed: (value: LastViewedObject) => void;
}

const Newsletter = ({ setLastViewed }: Props) => {
  const page = useFetchPage(setLastViewed);

  return (
    page && (
      <Page title={page.frontmatter.title} description={page.content}>
        <List items={page.frontmatter.newsletter} />
      </Page>
    )
  );
};

export default Newsletter;
